// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3kcg0","footer":"Form_footer__13K5m"};